module.exports = __webpack_public_path__ + "img/kosovo.944545e5.svg";